import { axios } from '@nsd/fe';

/**
 * Fetches the caller's client configuration document.
 * Company-Code is a global axios default header, so no params are sent.
 * @returns {Promise<Object|null>}
 */
export const getClientConfig = async () => {
  const { data } = await axios.get('/get-client-config');
  return data ?? null;
};
